export const trimExcerptModified = (text, contentLength = 22) => {
	const numWords = text.split(/\s+/).length;
	text.replace(/\[.*?\]/g, '');
	text.replace(']]>', ']]&gt;', text);
	text.replace('@<(script|style)[^>]*?>.*?</\\1>@si', '', text);
	text.trim();

	if (numWords > contentLength) {
		text = text.split(/\s+/).slice(0, contentLength).join(' ');
	}

	return `${text}...`;
};
